import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavArea from './Components/NavArea';
import Content from './Components/Content';
import Footer from './Components/Footer';

function App() {
  return (
    <div>
      <NavArea/>
      <Content/>
      <Footer/>
    </div>
  );
}

export default App;
